import type { ReactNode } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { Bold } from '#src/atoms/typography/Bold/index.tsx';
import { BodyM, HeadlineM } from '#src/atoms/typography/index.tsx';

const Container = styled(Vertical)`
  align-items: stretch;
`;
const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

type Description = MessageDescriptor | MessageDescriptor[];

export type Props = {
  title?: MessageDescriptor;
  description?: Description;
  toggleButton?: ReactNode;
};

const ToggleButton = styled.div``;

const SingleDescription = ({
  description,
}: {
  description: MessageDescriptor;
}) => (
  <BodyM color="var(--c-nd-600)">
    <FormattedMessage {...description} values={{ bold: Bold }} />
  </BodyM>
);

const DescriptionDisplayer = ({
  description,
}: {
  description: Description;
}) => {
  if (Array.isArray(description)) {
    return (
      <>
        {description.map(d => {
          return <SingleDescription key={d.id} description={d} />;
        })}
      </>
    );
  }
  return <SingleDescription description={description} />;
};

export const Header = ({ description, title, toggleButton }: Props) => (
  <>
    {!!(description || title) && (
      <SBHorizontal>
        <Container>
          {!!title && (
            <Title>
              <HeadlineM as="h4">
                <FormattedMessage {...title} />
              </HeadlineM>
            </Title>
          )}
          {!!description && <DescriptionDisplayer description={description} />}
        </Container>
        {!!toggleButton && <ToggleButton>{toggleButton}</ToggleButton>}
      </SBHorizontal>
    )}
  </>
);
